(function () {
    'use strict';

    angular
        .module('app.performanceReturnOnInvestmentReport',[])
        .factory('performanceReturnOnInvestmentReportService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope)
            {
                var service = {};

                function checkResponse(data) {
                    return data;
                }

                function getMessage(data) {
                    if (data) {
                        return data.message;
                    }
                    return false;
                }

                function handleRequest(url) {
                    var deferred = $q.defer(), result = 'requestFail';
                    $http.get(url)
                        .success(function (data) {
                            var dataRes = angular.fromJson(data);

                            if (checkResponse(dataRes)) {
                                deferred.resolve(dataRes);
                            } else {
                                deferred.reject(getMessage(dataRes) || result);
                            }
                        })
                        .error(function () {
                            deferred.reject(result);
                        });

                    return deferred.promise;
                }

                function getROIReportData(params)
                {
                    var url_getReturnOnInvestment = $rootScope.apiUrl + 'measure/getReturnOnInvestment?' + $.param(params);
                    return handleRequest(url_getReturnOnInvestment);
                }

                service.getROIReportData = getROIReportData;
                
                return service;
            }
        ]);
})();
